export type ChatMessageType = 'MESSAGE' | 'ZWINKER' | 'PRESENT' | 'FILE' | 'BUY_IMAGE';

export enum ChatMessageTypes {
    MESSAGE = 'MESSAGE',
    ZWINKER = 'ZWINKER',
    PRESENT = 'PRESENT',
    FILE = 'FILE',
    BUY_IMAGE = 'BUY_IMAGE',
}
